import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CountryOptionsService } from '../../shared/services/country-options.service';
import {
  loadCountryOptions,
  loadCountryOptionsFailure,
  loadCountryOptionsSuccess,
} from './country-options.actions';
import { of, switchMap } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class CountryOptionsEffects {
  private readonly actions$ = inject(Actions);
  private readonly service = inject(CountryOptionsService);

  public loadCountryOptions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCountryOptions),
      switchMap(() =>
        this.service.getCountryOptions().pipe(
          map((options) =>
            loadCountryOptionsSuccess({ countryOptions: options })
          ),
          catchError(() => of(loadCountryOptionsFailure()))
        )
      )
    )
  );
}
